// components/HeroBanner.jsx
import React from "react";
import { Box, Container, Stack, Typography, Chip } from "@mui/material";
import { getIconEl } from "./utils";

/**
 * Big visual banner used on several pages.
 * Props: { title, subtitle, image, height=400, chips=[], backgroundPosition="center" }
 */
export default function HeroBanner({
  title,
  subtitle,
  image,
  height = 400,
  chips,
  backgroundPosition = "center",
}) {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: Math.min(height, 260), sm: height },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        borderRadius: { xs: 1.5, sm: 2.5 },
        mb: { xs: 2.5, md: 4 },
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition,
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          insetInline: 0,
          bottom: 0,
          background: "linear-gradient(180deg, rgba(6,9,15,.22) 0%, rgba(6,9,15,.92) 100%)",
        },
      }}
    >
      <Container sx={{ position: "relative", zIndex: 1, textAlign: "center", py: 4 }}>
        <Stack spacing={2} alignItems="center">
          {getIconEl("SportsMotorsports", { fontSize: "large", color: "primary" })}
          <Typography variant="h2" component="h1" sx={{ fontSize: { xs: "clamp(2.25rem, 12vw, 3.25rem)", md: "4.25rem" }, textShadow: "0 4px 30px rgba(0,0,0,.7)" }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="h5" sx={{ fontSize: { xs: "1rem", sm: "1.25rem" }, maxWidth: 720, color: "text.secondary", textShadow: "0 2px 12px rgba(0,0,0,.8)" }}>
              {subtitle}
            </Typography>
          )}
          {chips && (
            <Stack direction="row" spacing={1} flexWrap="wrap" justifyContent="center">
              {chips.map((c) => (
                <Chip key={c} label={c} size="small" color="primary" variant="outlined" />
              ))}
            </Stack>
          )}
        </Stack>
      </Container>
    </Box>
  );
}
